import { render } from "./NavSidebar.vue?vue&type=template&id=08389fcd&scoped=true&ts=true"
import script from "./NavSidebar.vue?vue&type=script&lang=ts"
export * from "./NavSidebar.vue?vue&type=script&lang=ts"

import "./NavSidebar.vue?vue&type=style&index=0&id=08389fcd&scoped=true&lang=scss"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08389fcd"]])

export default __exports__